// extracted by mini-css-extract-plugin
module.exports = {"field":"SettingsField_field__3iQGB","label":"SettingsField_label__jALqx","input":"SettingsField_input__2Aj4V","editing":"SettingsField_editing__2rk5U"};